<template>
  <div>
    <el-drawer :visible.sync="addrSearch" :title="$t('goingTo')" size="100%" class="search-dialog" :with-header="false" :append-to-body="appendToBody">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('addrSearch')"> <i class="el-icon-arrow-left" style="padding-left: 13px;"></i> </div>
                <div class="search-title">{{$t('goingTo')}}</div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="text-align:left">
          <div style="height:60px; background-color:rgba(79, 76, 76, 1);position: relative;">
            <div @click="dialog_close('addrSearch')">
              <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
            </div>
            <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('goingTo')}}</div>
          </div>
        </div>
        <div class="search-header">
            <div class="search-center hotellist-region" style="width:96%;">
                <el-input :placeholder="$t('goingTo')" ref="regionPublic" v-model="input_region" @input="getDestinationList" @keyup.native="regionResult" clearable @clear="clearRegion" @blur="regionBlur" @click="regionFocus" @keyup.enter.native="getDestinationList"></el-input>
            </div>
        </div>
        <!-- <div class="search-line">
            <div class="search-center">
                <i class="el-icon-place"></i>
                <span>在我附近</span>
            </div>
        </div> -->
        <div class="search-main">
            <div class="search-main-line">
                <div class="search-center search-data-show" v-for="(value, key) in restaurantsAll" :key="key" style="width: 96%;margin: 0 auto;height: 50px;overflow: hidden;">
                  <div @click="regionSelect(value, value.type_id, value.type_data_id)" style="position: relative;top: 0px;left: 0px;height: 100%;padding: 0px 40px;">
                    <div style="width: 40px;float: left;text-align:center;position: absolute;top: 0px;left: 0px;" >
                      <div v-if="value.type == 'location'" class="locationClass"></div>
                      <div v-if="value.type == 'hotel'" class="hotelClass"></div>
                    </div>
                    <div class="search-main-line-left">
                        <div class="search-main-line-left-top" v-html="getLanguageHtml(value, 'value')"></div>
                        <div class="search-main-line-left-footer" v-html="getLanguageHtml(value, 'address')"></div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
        <div style="clear:both"></div>
    </el-drawer>
    <div style="clear:both"></div>

    <el-drawer :visible.sync="dateSearch" :title="$t('calendar')" size="100%" class="search-dialog" :with-header="false">
        <div class="search-header-date" :style="dateTopping">
            <!-- <div class="search-center">
                <div class="search-back" @click="dialog_close('dateSearch')"> <i class="el-icon-arrow-left"></i> </div>
                <div class="search-title">{{$t('calendar')}}</div>
                <div class="search-close"></div>
            </div> -->
            <div style="text-align:left">
              <div style="height:60px; background-color:rgba(79, 76, 76, 1);position: relative;">
                <div @click="dialog_close('dateSearch')">
                  <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
                </div>
                <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('calendar')}}</div>
              </div>
            </div>
            <div style="clear:both"></div>

            <div class="search-main-line">
                <div class="search-main-line-left">
                    <div class="search-main-line-all">
                        <div class="search-main-line-date">
                            <div class="search-main-line-check">{{$t('checkIn')}}</div>
                        </div>
                        <div class="search-main-line-month">
                            <div class="search-main-line-check">{{dayLs[0].tian}}</div>
                            <div class="search-main-line-checkday search-main-line-monthWork">
                                <div class="search-main-line-checkday-div">
                                  <span v-if="common.languageSet(this) === 'zh'">{{week[dayLs[0].week]}}</span>
                                  <span v-else>{{weekEn[dayLs[0].week]}}</span>
                                </div>
                                <div class="search-main-line-checkday-div search-main-line-checkday-month">
                                  <span v-if="common.languageSet(this) === 'zh'">{{dayLs[0].month}}月</span>
                                  <span v-else>{{monthEn[(dayLs[0].month-1)]}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="search-main-line-center">
                    <i class="el-icon-right"></i>
                </div>
                <div class="search-main-line-right">
                    <div class="search-main-line-all">
                        <div class="search-main-line-date">
                            <div class="search-main-line-check">{{$t('checkOut')}}</div>
                        </div>
                        <div class="search-main-line-month" v-if="dayLs[1].tian != ''">
                            <div class="search-main-line-check">{{dayLs[1].tian}}</div>
                            <div class="search-main-line-checkday search-main-line-monthWork">
                                <div class="search-main-line-checkday-div">
                                  <span v-if="common.languageSet(this) === 'zh'">{{week[dayLs[1].week]}}</span>
                                  <span v-else>{{weekEn[dayLs[1].week]}}</span>
                                </div>
                                <div class="search-main-line-checkday-div search-main-line-checkday-month">
                                  <span v-if="common.languageSet(this) === 'zh'">{{dayLs[1].month}}月</span>
                                  <span v-else>{{monthEn[(dayLs[1].month-1)]}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="clear:both"></div>

            <div class="search-main-date-week">
                <div v-if="common.languageSet(this) === 'zh'" v-for="item in week" :key="item">{{item}}</div>
                <div v-if="common.languageSet(this) === 'en'" v-for="item in weekEn" :key="item">{{item}}</div>
            </div>
            <div style="clear:both"></div>
        </div>
        <div style="clear:both"></div>
        <div class="search-month-date">
            <div class="search-month-one" v-for="(month, monthKey) in allDate" :key="monthKey">
                <div class="search-main-date-month-title">
                  <span v-if="common.languageSet(this) === 'en'"> {{common.monthMobileEn[(month.month-1)]}} ·</span>
                  {{month.year}}
                  <span v-if="common.languageSet(this) === 'zh'">  {{$t('yearN')}} {{month.month}} {{$t('month')}} </span>
                </div>
                <div class="search-main-date-week">
                    <div v-for="(day, daykey) in month.days" :key="daykey" class="search-main-date-day">
                        <div class="search-main-date-day-center" :class="[{'search-main-date-day-right': (checkDate[0] === (month.year + '-' + month.month + '-' + day) && checkDate.length === 2)} , {'search-main-date-day-left': (checkDate[1] === (month.year + '-' + month.month + '-' + day) && checkDate.length === 2)}, {'search-main-date-day-all': ((month.year + '-' + month.month + '-' + day) > checkDate[0] && (month.year + '-' + month.month + '-' + day) < checkDate[1] && day.indexOf('*') === -1)}, {'search-main-date-month-top': (day === '01')}, {'search-main-date-month-footer': (day === month.maxDay.toString())}]">
                            <span v-if="day.indexOf('*') !== -1" style="color:#ccc">{{day.replace('*','')}}</span>
                            <span v-else-if="day.indexOf('*') === -1" @click="selectedDay(month.year, month.month, day)" :class="[{'search-main-date-day-active':(checkDate.indexOf(month.year + '-' + month.month + '-' + day) !== -1)}]">
                                {{day}}
                            </span>
                        </div>
                    </div>
                    <div style="clear:both"></div>
                </div>
            </div>
        </div>
        <div class="search-month-button">
            <button @click="addDate"> {{$t('ok')}} ( {{daynight}} <span v-if="daynight<=1">{{$t('night')}}</span><span v-else>{{$t('nights')}}</span> ) </button>
        </div>
    </el-drawer>
    <div style="clear:both"></div>

    <el-drawer :visible.sync="personSearch" :title="$t('peopleNum')" size="100%" class="search-dialog" :with-header="false">
        <!-- <div class="search-header">
            <div class="search-center">
                <div class="search-back" @click="dialog_close('personSearch')"> <i class="el-icon-arrow-left"></i> </div>
                <div class="search-title">{{$t('peopleNum')}}</div>
                <div class="search-close"></div>
            </div>
        </div> -->
        <div style="text-align:left">
          <div style="height:60px; background-color:rgba(79, 76, 76, 1);position: relative;">
            <div @click="dialog_close('personSearch')">
              <i class="el-icon-arrow-left" style="color: white;height: 20px; width: 20px; font-size: 20px; position: absolute;margin: 20px 0px 20px 20px;"></i>
            </div>
            <div style="font-weight: 650; font-style: normal; font-size: 16px; color: #FFFFFF; text-align: center; height: 60px; line-height: 60px;">{{$t('peopleNum')}}</div>
          </div>
        </div>
        <div class="search-line">
            <div class="search-center">
                <div class="room-num"><div>{{roomNum}}</div></div>
                <div class="room-title">
                  <span v-if="roomNum<=1">{{$t('room')}}</span>
                  <span v-else>{{$t('rooms')}}</span>
                </div>
                <div class="room-button">
                  <button class="lass-button" :class="{'search-button-lass-gray': roomLessNoDo, 'search-button-lass-blue': roomLessDo}" @click="roomChange(1, $event)"></button>
                  <button class="add-button" :class="{'search-button-add-blue': roomAddDo, 'search-button-add-gray': roomAddNoDo}" @click="roomChange(2, $event)"></button>
                </div>
            </div>
            <div style="clear:both"></div>
        </div>
        <div class="search-line">
            <div class="search-center">
                <div class="room-num"><div>{{adultNum}}</div></div>
                <div class="room-title">
                  <span v-if="adultNum<=1">{{$t('adult')}}</span>
                  <span v-else>{{$t('adults')}}</span>
                </div>
                <div class="room-button">
                  <button class="lass-button" :class="{'search-button-lass-blue': adultLessDo, 'search-button-lass-gray': adultLessNoDo}" @click="adultChange(1, $event)"></button>
                  <button class="add-button" :class="{'search-button-add-blue': adultAddDo, 'search-button-add-gray': adultAddNoDo}" @click="adultChange(2, $event)"></button>
                </div>
            </div>
            <div style="clear:both"></div>
        </div>
        <div class="search-line">
            <div class="search-center">
                <div class="room-num"><div>{{childNum}}</div></div>
                <div class="room-title">
                  <span v-if="childNum<=1">{{$t('child')}}</span>
                  <span v-else>{{$t('children')}}</span>
                </div>
                <div class="room-button">
                  <button class="lass-button" :class="{'search-button-lass-blue': childLessDo, 'search-button-lass-gray': childLessNoDo}" @click="childChange(1, $event)"></button>
                  <button class="add-button" :class="{'search-button-add-blue': childAddDo, 'search-button-add-gray': childAddNoDo}" @click="childChange(2, $event)"></button>
                </div>
            </div>
            <div style="clear:both"></div>
        </div>
        <div v-show="showChildInfo">
          <div style="text-align: left;font-size: 13px;padding-left: 25px;margin: 10px 0px;" v-html="$t('childAge')" v-if="childNum<=1"></div>
          <div style="text-align: left;font-size: 13px;padding-left: 25px;margin: 10px 0px;" v-html="$t('childrenAges')" v-else></div>
          <div v-for="nums in childNum" :key="nums">
            <div class="search-line">
              <div class="child-center">
                  <div class="child-text">
                    <span style="margin-left:0px;">{{$t('childNum')}}</span>
                    {{nums}}
                  </div>
                  <div class="child-button">
                    <div v-if="selecteds[nums] == undefined">
                      <el-select class="selectOld" value="<1" placeholder="-" data-index="person-pc" @change="updateChildSelect(nums, $event)">
                        <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                      </el-select>
                    </div>
                    <div v-else>
                      <el-select class="selectOld" v-model="selecteds[nums]" placeholder="-" data-index="person-pc">
                        <el-option v-for="(value, key) in childOld" :key="key" :label="value" :value="value" data-index="person-pc" style="text-align:center"></el-option>
                      </el-select>
                    </div>
                  </div>
              </div>
              <div style="clear:both;"></div>
            </div>
          </div>
        </div>
        <div style="clear:both;height: 120px;"></div>
        <div class="search-month-button">
            <button @click="addPerson"> {{$t('ok')}} </button>
        </div>
    </el-drawer>
    <div style="clear:both;"></div>

  </div>
</template>

<script>
import { getHotelList } from '@/request/search.js'
const regionAll = [
  { 'id': '1', 'type': 'city', 'typename': '城市', 'value': '纽约，美国', 'address': '纽约，美国' },
  { 'id': '2', 'type': 'hotel', 'typename': '酒店', 'value': 'UMA公寓酒店', 'address': '曼谷，泰国' },
  { 'id': '3', 'type': 'hotel', 'typename': '酒店', 'value': '乌玛拉斯公寓酒店', 'address': '巴厘岛，印度尼西亚' }
]
export default {
  name: 'publicDateSearch',
  props: ['addrSearch', 'dateSearch', 'personSearch', 'regionSearch', 'checkDateSearch', 'selectedsSearch', 'roomNumSearch', 'adultNumSearch', 'childNumSearch', 'addrDateTime'],
  data () {
    return {
      regionAll: regionAll,
      restaurantsAll: regionAll,
      keywordOld: '',
      dateTopping: '',
      input_region: '',
      input_date: '',
      week: ['日', '一', '二', '三', '四', '五', '六'],
      weekEn: this.common.weekEn,
      monthEn: this.common.monthEn,
      allDate: [],
      checkDate: [],
      maxMonthNum: 12,
      dayLs: [{'tian': '', 'week': '', 'month': ''}, {'tian': '', 'week': '', 'month': ''}],
      daynight: 1,
      roomNum: 1,
      adultNum: 2,
      childNum: 0,
      submitInfo: [],
      selecteds: [],
      childOld: this.common.childOld,
      roomLessDo: false,
      roomLessNoDo: true,
      roomAddDo: true,
      roomAddNoDo: false,
      adultLessDo: true,
      adultLessNoDo: true,
      adultAddNoDo: false,
      adultAddDo: true,
      childLessDo: false,
      childLessNoDo: true,
      childAddDo: true,
      childAddNoDo: false,
      showChildInfo: false,
      appendToBody: false
    }
  },
  watch: {
    restaurantsAll: function (news, olds) {
      // console.log(news)
      this.$forceUpdate()
    },
    addrSearch: function (news) {
      // if (news === true && this.input_region === '') {
      //   this.$nextTick(() => {
      //     this.$refs.regionPublic.focus()
      //   })
      // }
    },
    regionSearch: function (news) {
      this.getDestinationList(news)
      this.input_region = news
    },
    checkDateSearch: function (news) {
      let start = news[0]
      let end = news[1]
      if (start !== undefined && start.length !== 0) {
        let parentInDate = new Date(start.replace(/-/g, '/'))
        var parentyearIn = parentInDate.getFullYear()
        var parentmonthIn = parentInDate.getMonth()
        var parenttianIn = parentInDate.getDate() < 10 ? '0' + parentInDate.getDate() : parentInDate.getDate()
        var monthSelectIn = (parentmonthIn + 1) < 10 ? '0' + (parentmonthIn + 1).toString() : (parentmonthIn + 1).toString()
        this.selectedDay(parentyearIn, monthSelectIn, parenttianIn)

        let parentOutDate = new Date(end.replace(/-/g, '/'))
        var parentyearOut = parentOutDate.getFullYear()
        var parentmonthOut = parentOutDate.getMonth()
        var parenttianOut = parentOutDate.getDate() < 10 ? '0' + parentOutDate.getDate() : parentOutDate.getDate()
        var monthSelectOut = (parentmonthOut + 1) < 10 ? '0' + (parentmonthOut + 1).toString() : (parentmonthOut + 1).toString()
        this.selectedDay(parentyearOut, monthSelectOut, parenttianOut)
      }
    },
    roomNumSearch: function (news) {
      this.roomNum = news
      if (news > 1) {
        this.roomLessDo = true
      }
    },
    adultNumSearch: function (news) {
      this.adultNum = news
      if (news > 1) {
        this.adultLessDo = true
      }
    },
    childNumSearch: function (news) {
      this.childNum = news
      if (news > 1) {
        this.childLessDo = true
      }
      if (news >= 1) {
        this.showChildInfo = true
        this.selecteds = this.selectedsSearch
      }
    },
    addrDateTime: function (news, olds) {
      this.allDate = []

      let d = new Date(news)
      var year = d.getFullYear()
      var month = d.getMonth()
      // 调用createCalendar()生成本月的日历
      for (let i = 0; i <= this.maxMonthNum; i++) {
        this.createCalendar(year, month, news)
        month += 1
        if (month > 11) {
          year += 1
          month = 0
        }
      }
      this.$forceUpdate()
    }
  },
  created () {
    // 初始化日历年月日
    let d = new Date()
    var year = d.getFullYear()
    var month = d.getMonth()
    var date = d.getDate()
    var initDay = year + '-' + ((parseInt(month) + 1) < 10 ? ('0' + (parseInt(month) + 1)) : (parseInt(month) + 1)) + '-' + (date < 10 ? ('0' + date) : date)
    // 调用createCalendar()生成本月的日历
    for (let i = 0; i <= this.maxMonthNum; i++) {
      this.createCalendar(year, month, initDay)
      month += 1
      if (month > 11) {
        year += 1
        month = 0
      }
    }

    var path = this.$route.path
    if (path === '/') {
      this.appendToBody = true
    }
  },
  beforeMount () {
    if (this.checkDateSearch !== undefined) {
      let start = this.checkDateSearch[0]
      let end = this.checkDateSearch[1]
      if (start !== undefined && start.length !== 0) {
        let parentInDate = new Date(start.replace(/-/g, '/'))
        var parentyearIn = parentInDate.getFullYear()
        var parentmonthIn = parentInDate.getMonth()
        var parenttianIn = parentInDate.getDate() < 10 ? '0' + parentInDate.getDate() : parentInDate.getDate()
        var monthSelectIn = (parentmonthIn + 1) < 10 ? '0' + (parentmonthIn + 1).toString() : (parentmonthIn + 1).toString()
        this.selectedDay(parentyearIn, monthSelectIn, parenttianIn)

        let parentOutDate = new Date(end.replace(/-/g, '/'))
        var parentyearOut = parentOutDate.getFullYear()
        var parentmonthOut = parentOutDate.getMonth()
        var parenttianOut = parentOutDate.getDate() < 10 ? '0' + parentOutDate.getDate() : parentOutDate.getDate()
        var monthSelectOut = (parentmonthOut + 1) < 10 ? '0' + (parentmonthOut + 1).toString() : (parentmonthOut + 1).toString()
        this.selectedDay(parentyearOut, monthSelectOut, parenttianOut)
      } else {
        let d = new Date()
        var year = d.getFullYear()
        var month = d.getMonth()
        var tian = d.getDate() < 10 ? '0' + d.getDate() : d.getDate()
        var monthSelect = (parseInt(month) + 1) < 10 ? '0' + (parseInt(month) + 1).toString() : (parseInt(month) + 1).toString()
        this.selectedDay(year, monthSelect, tian)
        this.selectedDay(year, monthSelect, parseInt(tian) + 1)
      }
    }
  },
  mounted () {
    // 获取目的地列表
    if (this._props.addrSearch === false) {
      this.getDestinationList('')
    }
  },
  methods: {
    getLanguageHtml: function (data, type) {
      if (data === undefined) {
        return ''
      }
      var getLanguage = this.common.languageSet(this)
      if (['value', 'address', 'typename'].includes(type)) {
        var typeLan = type + '_' + getLanguage
        return data[typeLan]
      }
    },
    getDestinationList: function (keyword) {
      /* if (typeof keyword !== 'string') {
        keyword = this.keywordOld
      }
      this.keywordOld = keyword
      this.regionAll = []
      this.restaurants = []
      var time = parseInt(new Date().getTime() / 1000)
      var dataJson = {'keyword': keyword, 'operation': 'getDestinationList', 'time': time, 'page': 30}
      var data = this.common.encryptionData(dataJson, this)
      getHotelList(data).then(res => {
        if (res.flag === '200') {
          this.regionAll = res.data
          this.restaurants = res.data
          // for (var datakey in res.data) {
          //   this.$set(this.regionAll, datakey, res.data[datakey])
          //   this.$set(this.restaurants, datakey, res.data[datakey])
          // }
          this.$forceUpdate()
        }
      }) */

      var that = this
      if (typeof keyword !== 'string') {
        this.$forceUpdate()
        return false
      }
      this.regionAll = []
      this.restaurantsAll = []
      this.keywordOld = keyword
      var requestTime = parseInt(new Date().getTime())
      var time = parseInt(requestTime / 1000)
      var dataJson = {'keyword': keyword, 'operation': 'getDestinationList', 'time': time, 'page': 30}
      var data = this.common.encryptionData(dataJson, this)
      getHotelList(data).then(res => {
        if (res.flag === '200') {
          that.regionAll = res.data
          that.restaurantsAll = res.data
          that.$forceUpdate()
        }
        return res
      }).then(res => {
        var responseTime = parseInt(new Date().getTime())
        this.$nextTick(() => {
          this.loadPageView(data, res, requestTime, responseTime)
        })
      })
    },
    regionResult: function () {
      // var region = this.$refs['regionPublic'].value
      // var restaurantsAll = this.regionAll
      // var results = region ? restaurantsAll.filter(this.createFilter(region)) : this.regionAll
      // this.restaurantsAll = results
    },
    createFilter (region) {
      return (restaurant) => {
        return (restaurant.value.toLowerCase().indexOf(region.toLowerCase()) !== -1)
      }
    },
    clearRegion: function () {
      this.restaurantsAll = this.regionAll
    },
    dialog_close: function (type) {
      if (type === 'addrSearch' && this.input_region === '') {
        var regionSel = {'value_zh': '', 'value_en': '', 'type_id': '', 'type_data_id': ''}
        // 保留选择的目的地
        sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

        var back = {'type': '', 'type_id': '', 'region': ''}
        this.$emit('getSonRegion', back)
        this.$emit('closepop', type)
      } else {
        this.$emit('closepop', type)
      }
    },
    createCalendar: function (year, month, initDay = '') {
      let init = new Date(initDay)
      let initYear = init.getFullYear()
      let initMonth = init.getMonth()
      let initDate = init.getDate()

      let d = new Date()
      // let curYear = d.getFullYear()
      // let curMonth = d.getMonth()
      let cursMonth = month + 1
      if (cursMonth < 10) {
        cursMonth = '0' + cursMonth.toString()
      }

      var monthDate = initDate
      if (initDay === '') {
        monthDate = d.getDate()
      }
      var monthData = {
        'year': year,
        'monthNum': month + 1,
        'month': cursMonth,
        'date': monthDate,
        'maxDay': new Date(year, month + 1, 0).getDate(),
        'days': []
      }

      d.setFullYear(year)
      d.setMonth(month)
      d.setDate(1)
      let dayOfFirstDay = d.getDay()
      var dateYear = d.getFullYear()

      // 向days数组填充每一个日期，包括上个与的末尾和下个月的开头总共42个日期
      /**
      *如何获得上个月末尾和下个月开头？
      *date对象可以设置年月日，其中设置每月几号为setDate(day) day一般为(1~31)
      *当day为0时，date设置的日期是上个月最后一天
      *当day为-1时，date设置的日期是上个月的倒数第二天，以此类推
      *当day设置超过当月天数时，比如三月的32，则会被设置为四月第一天
      *所以循环42次，每次设置对应的day，就可以生成完整日期数组，包括上月尾巴和下月的开头
      */
      for (let i = 0; i < 42; i++) {
        d.setDate(1)
        d.setMonth(month)
        d.setDate(i - dayOfFirstDay + 1)
        if (monthData.monthNum === (d.getMonth() + 1) && monthData.year === dateYear) {
          if (initMonth === d.getMonth() && initYear === d.getFullYear() && d.getDate() < (monthData.date)) {
            monthData.days.push((('0' + d.getDate()).slice(-2) + '*').toString())
          } else {
            monthData.days.push(('0' + d.getDate()).slice(-2).toString())
          }
        } else {
          monthData.days.push('*')
        }
      }

      this.allDate.push(monthData)
    },
    selectedDay: function (year, month, day) {
      if (this.checkDate.length >= 2) {
        this.checkDate = []
      }
      if (this.checkDate.indexOf(year + '-' + month + '-' + day) !== -1) {
        return false
      }

      this.checkDate.push(year + '-' + month + '-' + day)
      this.checkDate.sort()
      this.dayLs = []

      if (this.checkDate.length > 0) {
        var myDateIn = new Date(this.checkDate[0].replace(/-/g, '/'))
        var dayInfoIn = {
          'year': myDateIn.getFullYear(),
          'month': myDateIn.getMonth() + 1,
          'tian': (myDateIn.getDate() < 10) ? '0' + myDateIn.getDate().toString() : myDateIn.getDate().toString(),
          'week': myDateIn.getDay()
        }
        this.dayLs.push(dayInfoIn)

        var dayInfoIn2 = {
          'year': '',
          'month': '',
          'tian': '',
          'week': ''
        }
        this.dayLs.push(dayInfoIn2)
      }

      if (this.checkDate.length > 1) {
        this.dayLs.splice(1, 1)
        var myDateOut = new Date(this.checkDate[1].replace(/-/g, '/'))
        var dayInfoOut = {
          'year': myDateOut.getFullYear(),
          'month': myDateOut.getMonth() + 1,
          'tian': (myDateOut.getDate() < 10) ? '0' + myDateOut.getDate().toString() : myDateOut.getDate().toString(),
          'week': myDateOut.getDay()
        }
        this.dayLs.push(dayInfoOut)
      }

      this.daynight = 1
      if (this.checkDate.length === 2) {
        this.daynight = this.getDifferTime(this.checkDate[0], this.checkDate[1])
      }
    },
    // 计算两个日期差
    getDifferTime: function (startDate, endDate) {
      let startTime = new Date(Date.parse(startDate.replace(/-/g, '/'))).getTime()
      let endTime = new Date(Date.parse(endDate.replace(/-/g, '/'))).getTime()
      let dates = Math.abs((startTime - endTime)) / (1000 * 60 * 60 * 24)
      return dates
    },

    // 房间减少
    roomChange: function (type, e) {
      if (type === 1) {
        if (this.roomNum > 1) {
          this.roomNum--
          if (this.roomNum === 1) {
            this.roomLessDo = false
            this.roomLessNoDo = true
            return false
          }
          if (this.roomNum < 8) {
            this.roomAddNoDo = false
            this.roomAddDo = true
          }
        }
      } else {
        if (this.roomNum < 8) {
          this.roomNum++
          this.roomLessDo = true
          this.roomLessNoDo = false
          this.roomAddDo = true
          this.roomAddNoDo = false
          if (this.roomNum === 8) {
            this.roomLessDo = true
            this.roomLessNoDo = false
            this.roomAddDo = false
            this.roomAddNoDo = true
          }
          if (this.roomNum > this.adultNum) {
            this.adultNum = this.roomNum
            this.adultLessDo = true
            this.adultLessNoDo = false
          }
        }
      }
    },
    adultChange: function (type, e) {
      if (type === 1) {
        if (this.adultNum > 1) {
          this.adultNum--
          if (this.adultNum === 1) {
            this.adultLessDo = false
            this.adultLessNoDo = true
            return false
          }
          if (this.adultNum <= 10 && this.roomNum > this.adultNum) {
            this.roomNum = this.adultNum
            if (this.roomNum === 1) {
              this.roomLessDo = false
              this.roomLessNoDo = true
            }
            if (this.roomNum < 8) {
              this.roomAddNoDo = false
              this.roomAddDo = true
            }
          }
        }
      } else {
        this.adultNum++
        this.adultLessDo = true
        this.adultLessNoDo = false
      }
    },
    childChange: function (type, e) {
      if (type === 1) {
        if (this.childNum > 0) {
          this.childNum--
          if (this.childNum === 0) {
            this.childLessDo = false
            this.childLessNoDo = true
            this.childAddDo = true
            this.childAddNoDo = false
          }
        }
        if (this.childNum === 0) {
          this.showChildInfo = false
        }
        this.selecteds.pop()
      } else {
        if (this.childNum < 10) {
          this.childNum++
          this.childLessDo = true
          this.childLessNoDo = false
          if (this.childNum === 10) {
            this.childAddNoDo = true
            this.childAddDo = false
          }
        }
        if (this.childNum === 1) {
          this.showChildInfo = true
        }
        this.selecteds[this.childNum - 1] = '<1'
      }
    },
    addDate: function () {
      if (this.checkDate['1'] === undefined) {
        this.checkDate = this.searchDateDefault()
      }
      this.$emit('getSonDate', this.checkDate)
      this.$options.methods.dialog_close.bind(this)('dateSearch')
    },
    searchDateDefault: function () {
      var checkAddDate = []
      var startDate = new Date(this.checkDate['0'].replace(/-/g, '/'))
      var year = parseInt(startDate.getFullYear())
      var month = parseInt(startDate.getMonth())
      var tian = parseInt(startDate.getDate())
      month = parseInt(month + 1)

      var dayNum = parseInt(new Date(year, month, 0).getDate())

      if (tian >= dayNum) {
        tian = 0
        month = parseInt(month + 1)
      }

      if (month > 12) {
        month = 1
        year = parseInt(year + 1)
      }

      var monthSelect = month < 10 ? '0' + month.toString() : month.toString()
      var tianSelect = (parseInt(tian)) < 10 ? '0' + (parseInt(tian)).toString() : (parseInt(tian)).toString()
      checkAddDate.push(this.checkDate['0'])
      checkAddDate.push(year.toString() + '-' + monthSelect.toString() + '-' + tianSelect.toString())

      return checkAddDate
    },
    addPerson: function () {
      console.log(this.selecteds)
      var submitInfo = {'room': this.roomNum, 'adult': this.adultNum, 'child': this.childNum, 'childOld': this.selecteds}
      console.log(submitInfo)
      this.$emit('getSonPerson', submitInfo)
      this.$options.methods.dialog_close.bind(this)('personSearch')
    },
    regionSelect: function (value, type, typeId) {
      var name = value.value_en
      if (this.common.languageSet(this) === 'zh') {
        name = value.value_zh
      }
      this.input_region = name

      var regionSel = {'value_zh': value.value_zh, 'value_en': value.value_en, 'type_id': type, 'type_data_id': typeId}
      // 保留选择的目的地
      sessionStorage.setItem('regionSel', JSON.stringify(regionSel))

      var back = {'type': type, 'type_id': typeId, 'region': name, 'zDateTime': value.zDateTime}
      this.$emit('getSonRegion', back)
      this.$options.methods.dialog_close.bind(this)('addrSearch')
    },
    regionBlur: function () {
      // 获取焦点
      document.documentElement.scrollTop = document.body.scrollTop = 0
    },
    regionFocus: function () {
      this.$nextTick(() => {
        this.$refs.regionPublic.focus()
      })
    },
    updateChildSelect: function (num, e) {
      this.selecteds[num] = e
      this.$forceUpdate()
    }
  }
}
</script>

<style scoped>
  .el-drawer__body{ overflow: auto; }
  .el-drawer__container ::-webkit-scrollbar{ display: none; }
  .el-main{text-align: left;}
  .main{background-color: #fff;width:100%;}
  .el-drawer__wrapper{overflow: visible!important;}
  .search-dialog{width:100%;overflow: visible!important;}
  /*.search-dialog div{overflow:hidden;}*/

  .search-dialog .search-header{width:100%;min-height:50px;background:rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;}
  .search-dialog .search-center{width:100%;height:100%;margin:0 auto;overflow:auto;}
  .search-dialog .search-header .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
  .search-dialog .search-header .search-center .search-close{width:15%;height:100%;float:left;}
  .search-dialog .search-header .search-center .search-title{width:70%;height:100%;float:left;}
  .search-dialog .search-line{width:100%;min-height:50px;background:white;line-height:50px;text-align:left;font-size:16px;border-bottom:solid 1px #DCDFE2;}
  .search-dialog .search-line span{margin-left:2%;}

  /* 目的地 */
  .search-dialog .search-main{width:100%;height:100%;}
  .search-dialog .search-main .search-main-line{width:100%;min-height:50px;background:white;text-align:left;font-size:16px;}
  .search-dialog .search-main .search-main-line .search-main-line-left{width:100%;height:100%;float:left;text-align:left;height:50px;padding: 0px 40px 0px 0px;}
  .search-dialog .search-main .search-main-line .search-main-line-left-top{width:100%;height:55%;font-size:14px;line-height:35px;color:rgba(79, 76, 76, 1);overflow:hidden;white-space:nowrap;}
  .search-dialog .search-main .search-main-line .search-main-line-left-footer{width:100%;height:45%;font-size:14px;color:#999;overflow:hidden;white-space:nowrap;}
  .search-dialog .search-main .search-main-line .search-main-line-right{width:30%;height:100%;float:right;text-align:right;line-height:50px;height:50px;}
  .search-dialog .search-main .search-main-line .search-main-line-right button{border: solid 1px rgba(79, 76, 76, 1);background: white; color:rgba(79, 76, 76, 1); padding: 2px 25px;border-radius: 3px;}

  .search-dialog .hotellist-region /deep/ .el-input__inner{padding: 0 40px;background-image: url(https://res.roompai.com/static/img/input-region.png);background-repeat: no-repeat;background-size: 18px;background-position: 10px center;}
  .search-dialog .hotellist-region /deep/ .el-input__inner:focus,.hotellist-region input:focus{border-color:rgba(83, 102, 163, 1);box-shadow: 0px 0px 6px rgba(83, 102, 163, 1);}

  .search-dialog .locationClass{background: url(https://res.roompai.com/static/img/home/input-region.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  .search-dialog .hotelClass{background: url(https://res.roompai.com/static/img/home/hotel.png) 0% 0% / 18px;width: 100%;height: 54px;vertical-align: bottom;background-position: center center;background-repeat: no-repeat;}
  .search-dialog .hotellist-region /deep/ .el-input__suffix{font-size: 20px;width: 40px;height: 40px;margin-top: 1px;right:0px;}
  .search-dialog .hotellist-region /deep/ .el-input__suffix .el-input__clear{font-size: 20px;}

  /* 日历 */
  .search-dialog .search-header-date{width:100%;min-height:50px;background: rgba(79, 76, 76, 1);line-height:50px;text-align:center;font-size:16px;color:white;position:fixed;top:0px;left:0px;}
  .search-dialog .search-header-date .search-center .search-back{width:15%;height:100%;float:left;font-size:25px;text-align:left;}
  .search-dialog .search-header-date .search-center .search-close{width:15%;height:100%;float:left;}
  .search-dialog .search-header-date .search-center .search-title{width:70%;height:100%;float:left;}

  .search-dialog .search-header-date .search-main-line{width:100%;height:80px;background: rgba(79, 76, 76, 1);color:white;}
  .search-dialog .search-header-date .search-main-line .search-main-line-left{width:48%;height:100%;float:left;}
  .search-dialog .search-header-date .search-main-line .search-main-line-right{width:48%;height:100%;float:left;}
  .search-dialog .search-header-date .search-main-line .search-main-line-left .search-main-line-all{width: 88px;height: 100%;margin: 0 auto;}
  .search-dialog .search-header-date .search-main-line .search-main-line-right .search-main-line-all{width: 88px;height: 100%;margin: 0 auto;}
  .search-dialog .search-header-date .search-main-line .search-main-line-center{width:4%;height:100%;font-size:25px;float:left;text-align:center;line-height:80px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-date{width: 100%;text-align: left;float: left;line-height: 30px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-month{width:100%;height:48%;text-align:left;float:right;line-height:30px;}
  .search-dialog .search-header-date .search-main-line .search-main-line-month .search-main-line-check{width: 50%;height: 100%;float: left;font-size: 40px;text-align:right;}
  .search-dialog .search-header-date .search-main-line .search-main-line-checkday{width: 49%;height: 100%;font-size: 40px;line-height: 30px;float: right;}
  .search-dialog .search-header-date .search-main-line .search-main-line-checkday .search-main-line-checkday-div{width:100%;height:50%;font-size:14px;line-height:10px;padding-left:10px;}
  .search-dialog .search-header-date .search-main-line-checkday-month,.search-main-line-check{color:#eee;white-space: nowrap;}

  .search-dialog .search-header-date .search-main-date-week{width:100%;height:30px;line-height:30px;background:rgba(79, 76, 76, 1);color:white;margin:0 auto;}
  .search-dialog .search-header-date .search-main-date-week div{width:14.285%;height:100%;float:left;font-size: 12px;color: #eee;}
  .search-dialog .search-month-date{width:100%;margin:0 auto;text-align:center;margin-top:170px;margin-bottom: 15px;}
  .search-dialog .search-month-date .search-month-one{}
  .search-dialog .search-month-date .search-main-date-month-title{font-size:13px;background:#eee;font-weight:bold;color: #777;width:100%;height:25px;line-height:25px;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day{width:14.285%;height:40px;line-height:40px;float:left;font-size: 12px;color: black;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day div{width:100%; height:30px; margin: 5px auto; line-height: 30px;}
  .search-dialog .search-month-date .search-main-date-week .search-main-date-day div span{cursor:pointer;}

  .search-dialog .search-month-button{position: fixed;bottom: 0px;text-align: center;background: white;height: 60px;width: 100%;line-height:60px;}
  .search-dialog .search-month-button button{width: 90%;height: 80%;font-size: 14px;background: rgba(79, 76, 76, 1);color: white;font-weight: 500;border:none;box-shadow: 2px 2px 12px #dcdfe2;border-radius: 4px;}
  .search-dialog .search-month-button button:hover{background: rgb(252, 210, 5, 1);color: #000;border: none;}

  .search-main-date-day-active{background: rgba(79, 76, 76, 1);color:white;border-radius: 50%;/* padding: 4px 8px; */width: 30px;height: 100%;font-size: 12px;display: block;margin: 0 auto;}
  .search-main-date-day-left{background:linear-gradient(90deg,#DCDFE2 50%,#fff 50%);}
  .search-main-date-day-right{background:linear-gradient(90deg,#fff 50%,#DCDFE2 50%);}
  .search-main-date-day-all{background:#DCDFE2;}
  .search-main-date-month-top{border-radius: 20px 0px 0px 20px;}
  .search-main-date-month-footer{border-radius: 0px 20px 20px 0px;}

  /* 入住人数 */
  .search-dialog .search-line .search-center .room-num{width:15%;height:100%;float:left;margin-left:25px;}
  .search-dialog .search-line .search-center .room-title{width:20%;height:100%;float:left;}
  .search-dialog .search-line .search-center .room-button{width:45%;height:100%;float:right;text-align:right;font-size: 25px;margin-right:25px;}

  .child-text{ width:35%; height:100%;float:left;padding-left: 25px;}
  .child-button{ width:45%;height:100%;float:right;text-align:right;font-size: 25px;margin-right: 25px;}
  .child-center{width:100%;height:100%;margin:0 auto;}

  .lass-button{width: 25px;height: 25px;vertical-align:middle;border: none; background-color: #fff;}
  .add-button{width: 25px;height: 25px;vertical-align:middle;border: none; background-color: #fff;}
  .search-button-lass-gray{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-1-20x20.png");}
  .search-button-lass-blue{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-less-20x20.png");}
  .search-button-add-gray{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/2c2c2c-20x20.png");}
  .search-button-add-blue{background-position-x:center;background-size: 100%;background-repeat: no-repeat;background-image: url("https://res.roompai.com/static/img/hotelsearch/409EFF-20x20.png");}
  /deep/ .el-select-dropdown__wrap {max-height:200px!important;}
  /deep/ .el-popper[x-placement^=bottom]{margin-top: 0px;}
  /deep/ .el-popper[x-placement^=top]{margin-bottom: 0px;}
  .el-select{-webkit-tap-highlight-color: transparent !important;}
</style>



// WEBPACK FOOTER //
// src/components/public/publicSearch.vue